import './App.css';
import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import store, { persistor } from "./store/index.ts";
import { PersistGate } from "redux-persist/integration/react";
import { Provider, useSelector } from "react-redux";
import FullscreenLoader from "./components/fullscreenloader";

// Views
import EmailCapture from './components/emailCapture';
import Home from './views/home';
import Blog from './views/blog';
import BlogDetail from './views/blogDetail';
import About from './views/about';
import Social from './views/social-responsibility';
import Contact from './views/contact';
import CookiePolicy from './views/cookie-policy';
import TenPowerFoods from './views/ten-power-foods';
import Shop from './views/shop';
import ProductDetail from './views/product-detail';
import ShoppingCart from './views/shopping-cart';
import ShippingInfo from './views/shipping-info';
import ChooseCarrier from './views/choose-carrier';
import Payment from './views/payment';
import PaymentSuccess from './views/payment-success';
import Glossary from './views/glossary';
import ThankYou from "./views/thankyou";
import VideoRedirect from "./views/videoredirect";
import Analytics from "./components/analytics";
import Promotion from "./views/promotions"
import TermsAndConditions from './views/terms-and-conditions';

function AppContent() {
  const { loading, message } = useSelector((state) => state.loader);

  return (
    <>
      {loading && <FullscreenLoader message={message} />}
      <Routes>
        <Route path="/info" element={<EmailCapture />} />
        <Route path="/" element={<Home />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/blog-detail" element={<BlogDetail />} />
        <Route path="/about" element={<About />} />
        <Route path="/social-responsibility" element={<Social />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/ten-power-foods" element={<TenPowerFoods />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/shop/product/:paramSlug" element={<ProductDetail />} />
        <Route path="/shop/shopping-cart" element={<ShoppingCart />} />
        <Route path="/shipping-info" element={<ShippingInfo />} />
        <Route path="/choose-carrier" element={<ChooseCarrier />} />
        <Route path="/payment" element={<Payment />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/glossary" element={<Glossary />} />
        <Route path="/thank-you" element={<ThankYou />} />
        <Route path="/video" element={<VideoRedirect />} />
        <Route path="/promotion" element={<Promotion />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor} loading={null}>
        <BrowserRouter>
          <Analytics />
          <AppContent />
        </BrowserRouter>
      </PersistGate>
    </Provider>
  );
}

export default App;
